module.exports = "data:text/x-markdown;base64,VGhlIGdvYWwgb2YgdGhpcyBsZXZlbCBpcyBmb3IgeW91IHRvIHNldCB2YXJpYWJsZSBgY29tYmluZWRgIHRvIGB0cnVlYC4KCiZuYnNwOwpUaXBzOgoqIFVuZGVyc3RhbmRpbmcgaG93IHN0b3JhZ2Ugd29ya3MKCgo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/university.md
// module id = 1411
// module chunks = 0